import { useEffect } from "react";
import Nav from "../../components/Nav/Nav";
import Skills from "../../components/Skills/Skills";
import Projects from "../../components/Projects/Projects";
import Scroll from "../../components/Scroll/Scroll";
import Footer from "../../components/Footer/Footer";

const ProjetsPage = () => {    
    useEffect(() => {
    document.body.classList.add(localStorage.getItem("lang") || "hy");
    return () => {
        document.body.classList.remove(localStorage.getItem("lang") || "hy");
    };
}, []);
    return (
        <>
            <Nav />
            <Skills />
            <Projects />
            <Scroll />
            <Footer />
        </>
    );
}

export default ProjetsPage;